<template>
  <!-- Partners -->

  <div class="px-5 md:px-20 pt-20 pb-20 dark:bg-white">
    <div class="flex justify-between items-center">
      <div class="">
        <img
          src="/images/partner1.png"
          class="object-contain h-[50px] w-[50px] md:h-[100px] md:w-[200px]"
        />
      </div>
      <div class="">
        <img
          src="/images/partner2.png"
          class="object-contain h-[50px] w-[50px] md:h-[100px] md:w-[200px]"
        />
      </div>
      <div class="">
        <img
          src="/images/partner3.png"
          class="object-contain h-[50px] w-[50px] md:h-[100px] md:w-[200px]"
        />
      </div>
      <div class="">
        <img
          src="/images/partner4.png"
          class="object-contain h-[50px] w-[50px] md:h-[100px] md:w-[200px]"
        />
      </div>
      <div class="">
        <img
          src="/images/partner6.png"
          class="object-contain h-[50px] w-[50px] md:h-[100px] md:w-[200px]"
        />
      </div>
      <div class="">
        <img
          src="/images/partner5.png"
          class="object-contain h-[50px] w-[50px] md:h-[100px] md:w-[200px]"
        />
      </div>
    </div>
  </div>
</template>
